export const initState = {
    show: false,
    isLoading: false,
    isValid: true,
    errorMessage: '',
    error: [],
    success: {},
    getType() {
        return this.show ? 'text' : 'password';
    },
    resetMessages() {
        this.error = [];
        this.success = null;
    },
};
